/* unplugin-vue-components disabled */import { render } from "./OffPositionBizInfo.vue?vue&type=template&id=2851e3ac&scoped=true"
import script from "./OffPositionBizInfo.vue?vue&type=script&lang=js"
export * from "./OffPositionBizInfo.vue?vue&type=script&lang=js"

import "./OffPositionBizInfo.vue?vue&type=style&index=0&id=2851e3ac&lang=scss&scoped=true"

import exportComponent from "/Users/shinone/workingspace/xw/xwtec-assets-client/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.24_vue@3.5.24_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2851e3ac"]])

export default __exports__